if (!customElements.get('coin-product-tabs')) {
  customElements.define('coin-product-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      const tablist = this.querySelector('[role="tablist"]');
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const panels = tabs.map(tab => this.querySelector(`#${CSS.escape(tab.getAttribute('aria-controls'))}`));
      if (!tabs.length || panels.some(panel => !panel)) return;
      const shippingIndex = tabs.findIndex(tab => tab.id.startsWith('ShippingTab-'));
      const main = document.querySelector('.coin-product .m-main-product--wrapper');
      const specs = main?.querySelector('.coin-product__tablet-specs');
      const shipping = panels[shippingIndex];
      const tablet = window.matchMedia('(min-width: 768px) and (max-width: 1023px)');
      const shippingAnchor = document.createComment('Shipping panel position');
      const specsAnchor = document.createComment('Specifications position');
      const row = document.createElement('div');
      row.className = 'coin-product-content coin-product-content__tablet-row';
      let detached = false;
      if (main && specs && shipping) {
        shipping.before(shippingAnchor);
        specs.before(specsAnchor);
        main.after(row);
      }
      const activate = index => {
        this.activeIndex = index;
        tabs.forEach((tab, i) => {
          if (detached && i === shippingIndex) {
            tab.hidden = true;
            tab.setAttribute('aria-selected', 'false');
            tab.tabIndex = -1;
            shipping.hidden = false;
            shipping.removeAttribute('role');
            shipping.removeAttribute('aria-labelledby');
            shipping.removeAttribute('tabindex');
            return;
          }
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
          panels[i].setAttribute('role', 'tabpanel');
          panels[i].tabIndex = 0;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', event => {
          const visible = tabs.filter(item => !item.hidden);
          let next = visible.indexOf(tab);
          if (event.key === 'ArrowRight') next = (next + 1) % visible.length;
          else if (event.key === 'ArrowLeft') next = (next - 1 + visible.length) % visible.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = visible.length - 1;
          else return;
          event.preventDefault();
          activate(tabs.indexOf(visible[next]));
          visible[next].focus();
        });
      });
      let fitFrame;
      const fitShipping = () => {
        if (!shipping) return;
        shipping.style.removeProperty('height');
        shipping.style.removeProperty('--shipping-fit');
        if (!detached) return;
        const reference = specs.querySelector('.coin-product-specs');
        const height = reference?.getBoundingClientRect().height;
        if (!height) return;
        shipping.style.height = `${height}px`;
        const body = shipping.querySelector('.coin-product-content__body');
        if (!body) return;
        // Choose the roomiest readable spacing that fits the unchanged specs card.
        for (let step = 10; step >= 0; step--) {
          shipping.style.setProperty('--shipping-fit', step / 10);
          if (body.scrollHeight <= body.clientHeight + 1) break;
        }
      };
      const scheduleFit = () => {
        cancelAnimationFrame(fitFrame);
        fitFrame = requestAnimationFrame(fitShipping);
      };
      const fitObserver = new ResizeObserver(scheduleFit);
      if (specs) fitObserver.observe(specs);
      if (main) fitObserver.observe(main);
      const updateLayout = () => {
        detached = !!(tablet.matches && main && specs && shipping);
        if (detached) {
          row.append(specs, shipping);
          shipping.classList.add('coin-product-content__standalone');
        } else if (shippingAnchor.parentNode) {
          shippingAnchor.after(shipping);
          specsAnchor.after(specs);
          shipping.classList.remove('coin-product-content__standalone');
          tabs[shippingIndex].hidden = false;
          shipping.setAttribute('aria-labelledby', tabs[shippingIndex].id);
        }
        row.hidden = !detached;
        const first = tabs.findIndex((tab, i) => !detached || i !== shippingIndex);
        if (first >= 0) activate(first);
        else if (detached) activate(shippingIndex);
        this.hidden = first < 0;
        scheduleFit();
      };
      updateLayout();
      tablet.addEventListener('change', updateLayout);
      this.restoreLayout = () => {
        fitObserver.disconnect();
        cancelAnimationFrame(fitFrame);
        shipping?.style.removeProperty('height');
        shipping?.style.removeProperty('--shipping-fit');
        tablet.removeEventListener('change', updateLayout);
        if (shippingAnchor.parentNode) shippingAnchor.after(shipping);
        if (specsAnchor.parentNode) specsAnchor.after(specs);
        row.remove();
        shippingAnchor.remove();
        specsAnchor.remove();
      };
      this.querySelector('[role="tablist"]').hidden = false;
      this.dataset.ready = 'true';
    }
    disconnectedCallback() { this.restoreLayout?.(); }

  });
}
